<template>
    <div class="app-container">

        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">知识产权综合服务</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/zscqzhfw/zscqcs' }">知识产权超市</el-breadcrumb-item>
                    <el-breadcrumb-item>专利发布</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>

        <div class="form">
            <div class="tips">
                <span style="color:#E6A23C;">温馨提示：</span>请您严格遵守相关法律法规规定，严禁发布违法、反动、敏感等信息！
            </div>
            <el-form ref="form" :model="form" :rules="rules" label-width="150px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="专利号：" prop="patentNo">
                            <el-input v-model="form.patentNo" placeholder="请输入专利号,专利号示例：CN202010577800.5"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="专利名称：" prop="patentName">
                            <el-input v-model="form.patentName" placeholder="请输入专利名称"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="专利类型：" prop="patentType">
                            <el-radio-group v-model="form.patentType">
                                <el-radio v-for="dict in typeOptions" :key="dict.dictValue" :label="dict.dictValue">
                                    {{dict.dictLabel}}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="专利状态：" prop="patentStatus">
                            <el-radio-group v-model="form.patentStatus">
                                <el-radio v-for="dict in patentStatusOptions" :key="dict.dictValue"
                                          :label="dict.dictValue">
                                    {{dict.dictLabel}}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="技术领域：" prop="patentField">
                            <el-select style="width:100%" v-model="form.patentField" placeholder="请选择技术领域">
                                <el-option v-for="dict in fieldOptions" :key="dict.dictValue" :label="dict.dictLabel"
                                           :value="dict.dictValue"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发明(设计)人：">
                            <el-input v-model="form.patentInventor" placeholder="请输入发明（设计）人"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="申请(专利)人：">
                            <el-input v-model="form.patentApplicant" placeholder="请输入申请（专利）人"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="申请日期：">
                            <el-date-picker style="width:100%" clearable v-model="form.applyDate" type="date"
                                            value-format="yyyy-MM-dd" placeholder="选择申请日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="参考价格：">
                            <el-form-item>
                                <el-input type="number" v-model="form.patentPrice" placeholder="请输入价格"/>
                            </el-form-item>
                        </el-form-item>
                    </el-col>
                    <el-col class="remarks" align="left" :span="4">元 <span style="font-size:10px">不输入，默认为询价</span>
                    </el-col>
                    <!--<el-col class="remarks_1" :span="3" ></el-col>-->
                    <el-col :span="9">
                        <el-form-item label="联系方式：">
                            <el-form-item>
                                <el-input v-model="form.phone" placeholder="请输入联系方式"/>
                            </el-form-item>
                        </el-form-item>
                    </el-col>
                    <el-col class="remarks" :span="3">仅供登录用户查看</el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="专利摘要：">
                            <el-input type="textarea" :autosize="{ minRows: 5}" v-model="form.patentAbstract"
                                      placeholder="请输入专利摘要"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="附件上传：">
                            <attachment-list module="zscq_market" :businessid="form.annex"></attachment-list>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item>
                            <el-checkbox v-model="promise">我承诺：我所填写的发布内容及附件真实有效，我个人/单位对填写的内容真实性负责，如有虚假将依法承担相应责任。
                            </el-checkbox>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" class="btn">
                        <el-button type="info" @click="submitForm('N')">暂 存</el-button>
                        <el-button type="primary" @click="submitForm('Y')">提交</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <div class="notes">
                注：暂存后的信息可以再次编辑，提交并发布后的信息不可更改，等待审核通过后才可以在交易展示大厅中进行展示。
            </div>
        </div>

    </div>
</template>

<script>
    import {
        addMarket,
        updateMarket,
        getMarket,
    } from "@/api/zscq/market";
    import AttachmentList from "@/views/components/AttachmentList";
    // import {getToken} from "@/utils/auth";
    import {updatePvNum} from "@/api/itempv/pv";

    export default {
        name: "zscqcsRecord",
        components: {
            AttachmentList
        },
        data() {
            return {
                typeOptions: [],
                patentStatusOptions: [],
                fieldOptions: [],
                statusOptions: [],
                form: {
                    recid: undefined,
                    patentNo: undefined,
                    patentName: undefined,
                    patentType: "fm",
                    patentStatus: "yx",
                    patentField: undefined,
                    patentFields: [],
                    patentInventor: undefined,
                    patentApplicant: undefined,
                    applyDate: undefined,
                    patentPrice: undefined,
                    phone: undefined,
                    patentAbstract: undefined,
                    annex: undefined,
                    ywFwjgRecid: undefined,
                    ywSaveStatus:undefined,
                },
                promise: false,
                // 表单校验
                rules: {
                    patentNo: [{
                        required: true,
                        message: '请输入专利号',
                        trigger: 'blur'
                    }],
                    patentName: [{
                        required: true,
                        message: '请输入专利名称',
                        trigger: 'blur'
                    }],
                    patentType: [{
                        required: true,
                        message: '请选择专利类型',
                        trigger: 'change'
                    }],
                    patentStatus: [{
                        required: true,
                        message: '请选择专利状态',
                        trigger: 'change'
                    }],
                    patentField: [{
                        required: true,
                        message: '请选择所属领域',
                        trigger: 'change'
                    }],
					patentInventor: [{
						required: true,
						message: '请输入发明(设计)人',
						trigger: 'blur'
					}],
					patentApplicant: [{
						required: true,
						message: '请输入申请(专利)人',
						trigger: 'blur'
					}],
					applyDate: [{
						required: true,
						message: '请选择申请日期',
						trigger: 'change'
					}],
					patentPrice: [{
						required: true,
						message: '请输入参考价格',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入联系方式',
						trigger: 'blur'
					}],
					patentAbstract: [{
						required: true,
						message: '请输入专利摘要',
						trigger: 'blur'
					}],
                },
                recid: undefined,
				ywFwjgRecid:undefined
            }
        },
        created() {
            // this.getSdtyrzfwptLoginUser();
            this.getDicts("INDUSTRYPHY").then(response => {
                this.fieldOptions = response.data;
            });
            this.getDicts("patent_status").then(response => {
                this.patentStatusOptions = response.data;
            });
            this.getDicts("patent_type").then(response => {
                this.typeOptions = response.data;
            });
            updatePvNum("zscq_zscqcs_zrfb").then(response => {
                //pv 点击知识产权超市-转让发布
            });
            // this.getDicts("market_status").then(response => {
            //     this.statusOptions = response.data;
            // });
            this.recid = this.$route.params && this.$route.params.recid;
            if (this.recid != null && this.recid != undefined && this.recid != "") {
                // alert(this.recid);
                this.getDetail();
            }

            let annex = this.randomString();
            this.form.annex = annex;
			let ssessionLogin = JSON.parse(localStorage.getItem('ssessionLoginUser'));
			this.form.ywFwjgRecid = ssessionLogin.user.ywFwjgRecid;
			//----【】需要修改为recid
			this.ywFwjgRecid = ssessionLogin.user.ywFwjgRecid;
        },
        methods: {
            getDetail(){
                if (this.recid != null && this.recid != undefined) {
                    this.reset();
                    const recid = this.recid;
                    getMarket(recid).then(response => {
                        // console.log(response)
                        this.form = response.data;
                    });
                }
            },
            toPage(url) {
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            // 表单重置
            reset() {
                this.form = {
                    recid: undefined,
                    patentNo: undefined,
                    patentName: undefined,
                    patentType: "fm",
                    patentStatus: "yx",
                    patentField:undefined,
                    // patentFields: [],
                    patentInventor: undefined,
                    patentApplicant: undefined,
                    applyDate: undefined,
                    patentPrice: undefined,
                    phone: undefined,
                    patentAbstract: undefined,
                    publicNo: undefined,
                    publicDate: undefined,
                    applicantDom: undefined,
                    patentee: undefined,
                    mainClassifyNo: undefined,
                    ipc: undefined,
                    claims: undefined,
                    lxr: undefined,
                    annex: "",
                    fbDate: undefined,
                    status: "1",
                    isImport:"1",
                    ywAuditStatus:"1",
                };
                this.resetForm("form");
                let annex = this.randomString();
                this.form.annex = annex;
                let ssessionLogin = JSON.parse(localStorage.getItem('ssessionLoginUser'));
                this.form.ywFwjgRecid = ssessionLogin.user.ywFwjgRecid;
				//----需要修改为recid
                this.ywFwjgRecid = ssessionLogin.user.ywFwjgRecid;
                this.promise = false;
            },
            /** 提交按钮 */
            submitForm(status) {
				if (this.utils.isLoginTimeout()) {
					this.form.ywSaveStatus=status;
					this.$refs["form"].validate(valid => {
					    if (valid) {
					        if (this.promise) {
					            // this.form.patentField = this.form.patentFields;
					            this.$confirm(`是否${status =='Y' ?"提交" :"保存"}?`, '提示', {
					                confirmButtonText: '确定',
					                cancelButtonText: '取消',
					                type: 'warning'
					            }).then(() => {
					                this.saveForm();
					            })
					        } else {
					            this.msgError("请选择承诺");
					        }
					    }
					})
				} else {
					this.$confirm('登录已过期，您可以继续留在该页面，或者重新登录?', '提示', {
					    confirmButtonText: '确定',
					    cancelButtonText: '取消',
					    type: 'warning'
					}).then(() => {
					    this.logout(this.ywFwjgRecid)
					})
				}
            },
            saveForm() {
                if (this.form.recid != undefined) {
                    updateMarket(this.form).then(response => {
                        if (response.code === 200) {
                            this.msgSuccess("修改成功");
                            this.reset();
                            this.$router.back();
                        } else {
                            this.msgError(response.msg);
                        }
                    });
                } else {
                    addMarket(this.form).then(response => {
                        if (response.code === 200) {
                            this.msgSuccess("成功");
                            this.reset();
                            this.$router.back();
                        } else {
                            this.msgError(response.msg);
                        }
                    });
                }
            },
        }
    }
</script>

<style scoped>
    .app-container {
        padding: 0px 15px 20px;
        background-color: #ffffff;
    }

    .navigation {
        padding: 20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }

    .form {
        padding: 15px 5%;
        background-color: #FFFFFF;
    }

    .tips {
        line-height: 30px;
        text-align: center;
        background-color: #e6d7d7;
        margin-bottom: 1.875rem;
    }

    /deep/ .el-form-item__label {
        padding: 0 50px 0 0;
    }

    /deep/ .el-form-item__content {
        text-align: left;
    }

    .line {
        text-align: center;
    }

    .remarks {
        text-align: center;
        color: #999999;
        font-size: 12px;
        vertical-align: middle;
        line-height: 2.25rem;
    }

    .remarks_1 {
        text-align: center;
        color: #999999;
        font-size: 12px;
        vertical-align: middle;
        line-height: 1.2rem;
    }

    /deep/ .el-checkbox {
        color: #E6A23C;
        font-size: 12px;
    }

    .btn {
        text-align: center;
    }

    .btn .el-button + .el-button {
        margin-left: 30px;
    }

    .notes {
        padding: 20px 0px 10px;
        text-align: left;
        font-size: 12px;
        color: #999999;
    }

    /*.form-price /deep/.el-form-item__content{
        display: flex;
    }*/

</style>
